<template>
  <div class="about-us">
    <div class="menus-wrapper">
        <div class="menus" :style="{top: `${pageYOffset}px`}">
            <div v-if="association.introduce" :class="{'menu': true, 'current': menuIndex==1}">
              <a href="/AboutUs#section0" v-text="association.introduce1"></a>
            </div>
            <div v-if="association.concept" :class="{'menu': true, 'current': menuIndex==2}">
              <a href="/AboutUs#section1" v-text="association.concept1"></a>
            </div>
            <div v-if="association.regulation" :class="{'menu': true, 'current': menuIndex==3}">
              <a href="/AboutUs#section2" v-text="association.regulation1"></a>
            </div>
        </div>
    </div>
    <div class="content">
      <h1>學會簡介</h1>
      <div class="section">
        <h3 id="section0" class="mgt0"><strong v-text="association.introduce1"></strong></h3>
        <div v-html="association.introduce"></div>
      </div>
      <div class="section" v-if="association.concept">
        <h3 id="section1" class="mgt0"><strong v-text="association.concept1"></strong></h3>
        <div v-html="association.concept"></div>
      </div>
      <div class="section">
        <h3 id="section2" class="mgt0"><strong v-text="association.regulation1"></strong></h3>
        <div v-html="association.regulation"></div>
      </div>
        
        
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            flag: false,
            menuIndex: 1,
            pageYOffset: 0,
            association: this.$store.getters.association,
        }
    },
    mounted: function(){
        var hash = this.$route.hash
        if(hash == '#section0') {
            this.menuIndex = 1
        } else if(hash == '#section1') {
            this.menuIndex = 2
        } else if(hash == '#section2') {
            this.menuIndex = 3
        }
    },
    methods: {
        handleScroll (event) {
            if(this.flag) return
            this.flag = true
            setTimeout(() => {
                this.pageYOffset = window.pageYOffset
                this.flag = false
            }, 50)
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        $route: function(to, from) {
            var hash = this.$route.hash
            if(hash == '#section0') {
                this.menuIndex = 1
            } else if(hash == '#section1') {
                this.menuIndex = 2
            } else if(hash == '#section2') {
                this.menuIndex = 3
            }
        }
    }
};

</script>

<style scoped>
  .about-us {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    position: relative;
  }

  .about-us .menus {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 1px 1px 1px #e9e7e7;
  }

  .about-us .menus > .menu {
    height: 40px;
    line-height: 40px;
    margin: 0 8px;
    padding: 0 12px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    border-bottom: 1px solid #e8e8e8;
  }

  .about-us .menus > .menu.current {
    color: #f00;
  }

  .about-us .menus > .menu:last-child {
    border-bottom: 0;
  }

  .about-us > .menus-wrapper {
    margin: 0 10px;
  }

  .about-us > .content {
    flex: 1;
    background-color: #fff;
    padding: 0 12px;
    margin-right: 10px;
    box-sizing: border-box;
    border: 1px solid #e8e8e8;
    box-shadow: 1px 1px 1px #e9e7e7;
  }

  .about-us h1 {
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #1f1f1f;
  }

  .about-us h3 {
    font-size: 18px;
    font-weight: bold;
    color: #232323;
    line-height: 24px;
    margin-bottom: 12px;
  }

  .about-us .section {
    margin-bottom: 24px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    line-height: 21px;
    padding: 0 8px 24px 8px;
    box-sizing: border-box;
  }

  .about-us .section h3:target {
    color: #f00;
  }

  @media only screen and (max-width: 1050px) {
    .about-us {
      width: 100%;
      flex-direction: column;
    }

    .about-us > .content {
      margin: 10px;
    }
  }
</style>
